export enum MentionContentType {
  TEXT = 'text',
  MENTION = 'mention',
}

export enum MentionNodeAttribute {
  ID = 'id',
  LABEL = 'label',
}
